module.exports = __webpack_public_path__ + "img/1.59fc3b2e.png";